import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    redirect: "/accessManage",
    component: resolve => require(["@/views/layout/layout.vue"], resolve)
  },{
    path: '/Layout',
    name: 'Layout',
    component: resolve => require(["@/views/layout/layout.vue"], resolve),
    children:[
      {
        path: "/accessManage",
        name: "accessManage",
        component: resolve => require(["@/views/accessManage/index.vue"], resolve),
        meta: {
          title: "出入口管理",
        }
      },{
        path: "/monitor",
        name: "monitor",
        component: resolve => require(["@/views/monitor/index.vue"], resolve),
        meta: {
          title: "实时监控",
        }
      },{
        path: "/record",
        name: "record",
        component: resolve => require(["@/views/record/index.vue"], resolve),
        meta: {
          title: "进出场记录",
        }
      },
    ]
  },
   {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  }, 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
